<template>
  <div class="top_quires mt-0">
    <p class="heading">Top Queries</p>
    <div class="loader_con" v-if="!isClicked">
      <p>Please Select a Date Range and Term</p>
    </div>
    <div v-else>
      <div class="loader_con" v-if="isApicalled">
        <v-progress-circular
          indeterminate
          color="#1F8F58"
          size="40"
        ></v-progress-circular>
      </div>

      <div v-else-if="queryData.queries.length === 0" class="loader_con">
        <p>No data present</p>
      </div>
      <div v-else class="query_list_box">
        <div
          class="list"
          v-for="(item, index) in queryData.queries"
          :key="index"
        > 
          <div class="flex query_text_con">
            <p style="width:16px; font-size: 14px !important;margin-top: 4px;margin-left:4px">{{ index + 1 }}.</p>
          
            <p style="margin-left:8px;margin-top: 4px; !important" >{{ item.text }}</p>
          </div>

          <!-- <div v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
              <div class="flex query_text_con">
               <p style="width:10px; font-size: 14px !important;margin-top: 4px;margin-left:4px">{{ index + 1 }}.</p>
                <p style="margin-left:4px;margin-top: 4px; !important" v-bind="attrs" v-on="on">
                  {{ item.text }}
                </p>
              </div>
              </template>
              <span>{{ item.text }}</span>
            </v-tooltip>
          </div> -->
          <div style="border: 1px solid #f3f3f3"></div>
        </div>
        <!-- <div class="list" v-for="(item, index)  in queryData.queries" :key="item.text">
                    <div class="flex query_text_con">
                        <p class="query_text">{{ index + 1 }}. </p>
                        <p class="query_text"> {{ item.text }}</p>
                    </div>

                    <div style="border: 1px solid #F3F3F3"></div>
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import API_URL from "../../../../helpers/apiUrls";

export default {
  name: "topQueries",
  data() {
    return {
      queryData: [],
      isApicalled: false,
      isClicked: false,
      nodata : false,
    };
  },
  mounted() {
    console.log("QUERY MOUNTED");
    console.log("DATA", this.data);
    // this.getQuerytext();
  },
  props: {
    data: {
      type: Object,
    },
    click: {
      type: Boolean,
    },
  },
  watch: {
    click: function () {
      if(this.data.selectTerm){
        this.isApicalled = true;
        this.getQuerytext();
        this.isClicked = true;
      } else {
        this.isClicked = false;
      }
    },
  },
  methods: {
    getQuerytext() {
      const successHandler = (response) => {
        if (response.status === 200) {
          this.isApicalled = false;
          this.queryData = response.data;
          // console.log("HERE===>",response.data.queries);
          // if(this.queryData.total_result == )
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
        this.isApicalled = false;
        this.isLoading = false;
      };

      var datastr = "-01";
      var startMonth = this.data.startMonth.concat(datastr);
      var endMonth = this.data.endMonth.concat(datastr);

      const data = {
        start_date: startMonth,
        end_date: endMonth,
        states: this.data.states,
        query: this.data.selectTerm,
        limit: 15,
        offset: 0,
      };

      this.newRequestPOST(
        `${API_URL.getTopqueries}`,
        // "https://run.mocky.io/v3/a3ca1246-67e9-4256-a3e5-0fe0a10f754a",
        data,
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_DISCOVERY
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.top_quires {
  background-color: #fbfbfb;
  height: 300px;
  border-radius: 8px;
 
}
.loader_con {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  //  background-color: red;

  p {
    color: #999999;
    font-size: 0.9rem;
    font-family: "Lucida Grande", "Lucida Sans Unicode", Verdana, Arial,
      Helvetica, sans-serif;
  }
}
.heading {
  padding-top: 18px !important;
  margin-left: 18px;
  font-weight: 500;
  font-size: 16px;
}

.query_list_box {
  border: 0.5px solid #bfbfbf;
  margin: 18px;
  border-radius: 7px;
  height: 220px;
  overflow: hidden;
  overflow-y: scroll;
  width: 90%;
}
.query_text_con {
  justify-content: flex-start;
  width: 90%;

}
.list {
  padding: 4px;
}
.query_line{
  
  overflow: hidden;
  //@at-rootwidth: 10%;
  // width: 400px;
  text-overflow: ellipsis;
  white-space: nowrap; 
  
  
}
.query_text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  margin-top: 4px;
  margin-left: 12px;
  
  
    
}
.v-tooltip__content {
  background-color: #fff;
  color: #445149;
  /* background: #D8D8D8; */
  border: 0.6px solid #979797;
  border-radius: 5px;
  max-width: 600px;
  min-width: 200px;
  text-align: center;
  font-size: 13px;
  padding: 10px 12px;
}
</style>
